import { get } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { Table } from "semantic-ui-react"

const LogsTable = ({ logs, onSelect, selected }) => (
	<Table selectable>
		<Table.Header>
			<Table.Row>
				<Table.HeaderCell>Id</Table.HeaderCell>
				<Table.HeaderCell>Typ</Table.HeaderCell>
				<Table.HeaderCell>Waga</Table.HeaderCell>
				<Table.HeaderCell>Treść</Table.HeaderCell>
				<Table.HeaderCell>Id jednostki</Table.HeaderCell>
				<Table.HeaderCell>Data</Table.HeaderCell>
			</Table.Row>
		</Table.Header>
		<Table.Body>
			{logs.map((log, index) => (
				<Table.Row
					active={get(log, "logId") === get(selected, "logId")}
					key={index}
					onClick={event => onSelect(event, log)}>
					<Table.Cell>{get(log, "logId")}</Table.Cell>
					<Table.Cell>{get(log, "type")}</Table.Cell>
					<Table.Cell>{get(log, "weight")}</Table.Cell>
					<Table.Cell>{get(log, "msg")}</Table.Cell>
					<Table.Cell>{get(log, "unitId")}</Table.Cell>
					<Table.Cell>{get(log, "data")}</Table.Cell>
				</Table.Row>
			))}
		</Table.Body>
	</Table>
)

LogsTable.propTypes = {
	logs: PropTypes.array,
	onSelect: PropTypes.func.isRequired,
	selected: PropTypes.object
}

LogsTable.defaultProps = {
	logs: []
}

export default LogsTable



// WEBPACK FOOTER //
// ./src/containers/logs/components/LogsTable.js